// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dph-panel {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px;
}

.dph-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.dph-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.dph-collapse-btn {
  min-width: 30px;
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #111827;
  cursor: pointer;
}

.dph-collapse-btn--collapsed {
  width: 100%;
  height: auto;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 14px;
  color: #111827;
  background: #ffffff;
  text-align: center;
}

.dph-collapsed-wrap {
  width: 100%;
}

.dph-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
}

.dph-row--create {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.dph-label {
  font-size: 13px;
  color: #111827;
}

.dph-select,
.dph-input {
  width: 100%;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-sizing: border-box;
  background: #ffffff;
}

.dph-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.dph-btn {
  min-height: 38px;
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 13px;
}

.dph-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dph-btn--green {
  background: #16a34a;
  color: #ffffff;
}

.dph-btn--blue {
  background: #2563eb;
  color: #ffffff;
}

.dph-btn--white {
  background: #ffffff;
  color: #111827;
  border: 1px solid #cbd5e1;
}`, "",{"version":3,"sources":["webpack://./src/components/designer/page/DesignerPageHeaderControls.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".dph-panel {\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 10px;\n}\n\n.dph-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.dph-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.dph-collapse-btn {\n  min-width: 30px;\n  height: 30px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #111827;\n  cursor: pointer;\n}\n\n.dph-collapse-btn--collapsed {\n  width: 100%;\n  height: auto;\n  padding: 10px 12px;\n  font-weight: 700;\n  font-size: 14px;\n  color: #111827;\n  background: #ffffff;\n  text-align: center;\n}\n\n.dph-collapsed-wrap {\n  width: 100%;\n}\n\n.dph-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.dph-row--create {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.dph-label {\n  font-size: 13px;\n  color: #111827;\n}\n\n.dph-select,\n.dph-input {\n  width: 100%;\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  box-sizing: border-box;\n  background: #ffffff;\n}\n\n.dph-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.dph-btn {\n  min-height: 38px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.dph-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.dph-btn--green {\n  background: #16a34a;\n  color: #ffffff;\n}\n\n.dph-btn--blue {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.dph-btn--white {\n  background: #ffffff;\n  color: #111827;\n  border: 1px solid #cbd5e1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
